import React from "react";
import styled from "styled-components";
import { ReactComponent as Minus } from "../../../../assets/icons/MinusGhost.svg";
import { theme } from "../../../../theme";

interface Props {
  onClick?: () => void;
  disabled?: boolean;
}
const MinusGhostButton: React.FC<Props> = ({ onClick, disabled }) => {
  return (
    <StyledMinusIcon
      onClick={onClick}
      stroke={disabled ? theme.colors.gray6 : theme.colors.red3}
      fill={disabled ? theme.colors.gray6 : theme.colors.red3}
    />
  );
};

const StyledMinusIcon = styled(Minus)`
  cursor: pointer;
  height: 32px;
  margin: 0px;
`;
export default MinusGhostButton;
